export default __webpack_public_path__ + "assets/xml/688e754d1dd1f2ede8447653a22c9e98.xml";